import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notificationCounter: 0,
    user: "",
    alert: {
      visible: false,
      type: "",
      message: "",
      detailMessage: "",
      confirmHandler: null,
      hideHandler: null
    },
    updatePassword: false
  },
  mutations: {
    setNotificationBadge (state) {
      return state.notificationCounter
    },
    setUser (state, user) {
      state.user = user
    },
    alert (state, update) {
      let [visible, type, message, detailMessage, confirmHandler, hideHandler] = update
      if (!visible) {
        state.alert.visible = false
        return
      }
      state.alert.type = type
      state.alert.message = message
      state.alert.detailMessage = detailMessage
      state.alert.visible = true
      state.alert.confirmHandler = confirmHandler
      state.alert.hideHandler = hideHandler
    },
    setPasswordUpdate (state, update) {
      state.updatePassword = update
    }  
  }
})